import React from 'react'
import Button from "../Button";
import {type EntityType, type SelectedItem, type SelectedItemsData} from "../EntitySelector/EntitySelector.types";
import {SelectedItems} from "./SelectedItems";

// Types ----

type SelectedItemsWrapperProps = {
  selectedItems: SelectedItemsData
  selectedItemCount: number
  onRemoveItem: <K extends EntityType>(item: SelectedItem<K>, entityType: K) => void
  onClearItems?: () => void
  isMultiSite?: boolean
}

// Component ----

function SelectedItemsWrapper({ selectedItems, selectedItemCount, onRemoveItem, onClearItems, isMultiSite }: SelectedItemsWrapperProps) {
  function handleClearItems() {
    onClearItems?.();
  }

  return (
    <div className='shadow-md rounded-md border border-gray-200'>
      <div className='flex items-center gap-x-2.5 justify-between px-4 py-3 border-b border-b-gray-200'>
        <h4 className='text-gray-600 text-md'>Selected Items • {selectedItemCount}</h4>
        <Button
          color={Button.colors.WHITE}
          size={Button.sizes.X_SMALL}
          onClick={handleClearItems}
          disabled={!selectedItemCount}
        >
          Clear all
        </Button>
      </div>

      <div className='flex flex-col gap-5 h-[46vh] overflow-y-auto relative pb-4 px-4'>
        <SelectedItems selectedItems={selectedItems} onRemoveItem={onRemoveItem} isMultiSite={isMultiSite} />
      </div>
    </div>
  );
}

export {SelectedItemsWrapper};